import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/entities/Confirmation/ui/ConfirmationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/widgets/AdminTooltip/ui/AdminTooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/app/apps/web/trpc/react.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/jotai@2.12.5_@types+react@19.0.14_react@19.0.3/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/.pnpm/nuqs@2.4.3_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["Rwdot"] */ "/app/node_modules/.pnpm/rwdot@0.0.5_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/rwdot/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/sonner@1.7.4_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/sonner/dist/index.mjs");
